import {
    resourceGetDetail,
    resourceGetList,
    resourcePatchDetail,
    resourcePostList,
} from "shared/djangio/action-creators"

import { segueToEditAlert } from "global-action-creators"
import actionTypes, * as actionGroups from "alerts/action-types"

export const deleteAlert = (alertId) =>
    resourcePatchDetail(
        DjangIO.app.userdata.alerts.models.Alert,
        actionGroups.deleteAlertTypes,
        alertId,
        { archived: true },
        { alertId },
        true
    )

export const getUsers = () =>
    resourceGetList(DjangIO.app.userdata.models.QuorumUser, actionGroups.getUsersTypes, { limit: 1000 }, {}, true)

export const getAlert = (alertId) =>
    resourceGetDetail(
        DjangIO.app.userdata.alerts.models.Alert.objects.full_dehydrate("user"),
        actionGroups.getAlertTypes,
        alertId,
        { alertId },
        false
    )

export const getAlertGroups = (user = Userdata.id) =>
    resourceGetList(
        DjangIO.app.userdata.alerts.models.AlertGroup,
        actionGroups.getAlertGroupsTypes,
        { limit: 1000, user },
        {},
        true
    )

export const getSavedSearch = (savedSearchId) =>
    resourceGetDetail(
        DjangIO.app.userdata.models.SafedSearch,
        actionGroups.getSavedSearchTypes,
        savedSearchId,
        { savedSearchId },
        true
    )

export const editSavedSearch = (savedSearch) => (dispatch) =>
    dispatch({ type: actionTypes.PATCH_SAVED_SEARCH_SUCCESS, response: savedSearch })

export const clearSavedSearch = () => (dispatch) => dispatch({ type: actionTypes.CLEAR_SAVED_SEARCH })

export const getAlertBySavedSearch = (savedSearchId) =>
    resourceGetList(
        DjangIO.app.userdata.alerts.models.Alert.objects.full_dehydrate("user"),
        actionGroups.getAlertBySavedSearchTypes,
        { safed_search: savedSearchId },
        { savedSearchId },
        true
    )

export const getAlertByModelAndDatumId = (model, datumId) => {
    const qdt = DjangIO.app.models.QuorumDataType.by_value(model)
    return resourceGetList(
        DjangIO.app.userdata.alerts.models.Alert.objects.full_dehydrate("user"),
        actionGroups.getAlertTypes,
        { [qdt.related_field]: datumId, user: window.Userdata.id },
        {},
        true
    )
}

export const getOrCreateAlertFromDatumId =
    (model, datumId, name, region = "") =>
    async (dispatch) => {
        // First check if there's an alert with this model/datumId already
        const response = await dispatch(getAlertByModelAndDatumId(model, datumId))
        const alert = response.objects ? response.objects.length && response.objects[0] : response

        // If there is no alert, create a saved search
        if (!alert) {
            const qdt = DjangIO.app.models.QuorumDataType.by_value(model)
            // Create an alert using the model and datumId
            const saved_search = {
                user: DjangIO.app.userdata.models.QuorumUser.foreignKey(parseInt(Userdata.id)),
                data_type: model,
                name: name || `-${qdt.label} Alert-`,
                added_ids: [datumId],
                filters: [],
            }

            await dispatch(
                resourcePostList(
                    DjangIO.app.userdata.models.SafedSearch,
                    actionGroups.createAlertFromDatumIdTypes,
                    saved_search,
                    {
                        model,
                        datumId,
                        name,
                        estimated_count: 1,
                    },
                    true
                )
            )
        }
    }

export const createAlertFromListId = (listId, model, name) => async (dispatch) => {
    const saved_search = {
        user: DjangIO.app.userdata.models.QuorumUser.foreignKey(parseInt(Userdata.id)),
        data_type: model,
        name: name || `-List Alert-`,
        filters: [{ in_list_or: [listId] }],
    }

    const result = await dispatch(
        resourcePostList(
            DjangIO.app.userdata.models.SafedSearch,
            actionGroups.postSavedSearchTypes,
            saved_search,
            { listId, model },
            true
        )
    )
    dispatch(segueToEditAlert(model, result.id, true, true))
}

export const createSavedSearchFromDatumId = (model, datumId, name) => async (dispatch) => {
    const saved_search = {
        user: DjangIO.app.userdata.models.QuorumUser.foreignKey(parseInt(Userdata.id)),
        data_type: model,
        name: name || `-${DjangIO.app.models.QuorumDataType.by_value(model).label}-`,
        added_ids: [datumId],
        filters: [],
    }

    const result = await dispatch(
        resourcePostList(
            DjangIO.app.userdata.models.SafedSearch,
            actionGroups.postSavedSearchTypes,
            saved_search,
            {
                model,
                datumId,
                name,
                estimated_count: 1,
            },
            true
        )
    )
    return result
}
